import { baseDocSerializer, docTypeHash } from "@megaron/resource";
import { Serializers, SerializerValue } from "@megaron/serializers";

export const syncChannelDocSerializer = Serializers.object({
  ...baseDocSerializer("sync-channel").fields,
  channel: Serializers.string,
  changeCount: Serializers.integer,
  errorCount: Serializers.integer,
});

export type SyncChannelDoc = SerializerValue<typeof syncChannelDocSerializer>;

export const syncChannelDocTypeHash = docTypeHash(syncChannelDocSerializer);
